"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Typography = require("../Typography");

var _Layout = require("../Layout");

var _Quote = require("./Quote.style");

var Quote = function Quote(_ref) {
  var variant = _ref.variant,
      copy = _ref.copy,
      name = _ref.name,
      jobTitle = _ref.jobTitle,
      company = _ref.company,
      image = _ref.image,
      id = _ref.id;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      quotes = _ref2.quotes;

  var quotedCopy = image ? "\"".concat(copy, "\"") : "".concat(quotes.noImageIcon).concat(copy).concat(quotes.noImageIcon);
  return /*#__PURE__*/_react.default.createElement(_Quote.QuoteWrapper, {
    image: image,
    variant: variant,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_Layout.Container, null, /*#__PURE__*/_react.default.createElement(_Layout.Grid, null, /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    width: "12"
  }, /*#__PURE__*/_react.default.createElement(_Quote.QuoteGrid, {
    image: image
  }, image && /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    pr: [4, null],
    width: [6, 3, 2, 2, 2]
  }, /*#__PURE__*/_react.default.createElement(_Quote.QuoteImage, Object.assign({}, image, {
    mediaType: "backgroundImage"
  }))), !image && quotes.showQuotation && /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    pr: [4, null],
    width: [2, 1, 2, 2, 2],
    position: "relative"
  }, /*#__PURE__*/_react.default.createElement(_Quote.Quotation, null)), /*#__PURE__*/_react.default.createElement(_Quote.QuoteCopyColumn, {
    width: image ? quotes.columnWidthWithImage : quotes.columnWidthNoImage,
    image: image
  }, /*#__PURE__*/_react.default.createElement(_Quote.QuoteCopy, {
    size: quotes.quoteCopyFontSize
  }, quotedCopy), /*#__PURE__*/_react.default.createElement(_Quote.QuoteName, {
    size: quotes.quoteDetailsFontSize
  }, name), /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    size: quotes.quoteDetailsFontSize
  }, jobTitle), /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    size: quotes.quoteDetailsFontSize
  }, company)))))));
};

Quote.propTypes = {
  id: _propTypes.default.string,
  copy: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  jobTitle: _propTypes.default.string,
  company: _propTypes.default.string,
  image: _propTypes.default.shape(Object),
  variant: _propTypes.default.oneOf(['default', 'primary'])
};
Quote.defaultProps = {
  id: '',
  variant: 'default',
  image: null,
  jobTitle: '',
  company: ''
};
var _default = Quote;
exports.default = _default;